export const BusinessTier = {
  Basic: 1,
  Standard: 2,
  Premium: 3
};
